// extracted by mini-css-extract-plugin
export default {"text":"ReplaceTextToHtml_text__eKnaB","title":"ReplaceTextToHtml_title__ne6qS","link":"ReplaceTextToHtml_link__5OsNo"};